export default "__VITE_ASSET__Bn$Lp8UP__"